import { makeStyles } from "@material-ui/core/styles";

const getPos = (offset) => ({ isLarge }) => offset ? -16 : (isLarge ? -10 : -9)
const getWidth = ({ isLarge }) => isLarge ? 10 : 9

const useStyle = makeStyles(() => ({
  trigger: {
    position: "absolute",
    opacity: 0,
    backgroundColor: "rgba(255, 255, 255, 0.6) !important",
    "$host:hover &": {
      opacity: 1,
      pointerEvents: "auto",
    },
    "&.top, &.bottom": { left: "50%", transform: "translateX(-50%)" },
    "&.left, &.right": { top: "50%", transform: "translateY(-50%)" },
    "&.top": { top: getPos() },
    "&.top.offset": { top: getPos(true) },
    "&.bottom": { bottom: getPos() },
    "&.bottom.offset": { bottom: getPos(true) },
    "&.left": { left: getPos() },
    "&.left.offset": { left: getPos(true) },
    "&.right": { right: getPos() },
    "&.right.offset": { right: getPos(true) },
  },
  host: {
    position: "absolute",
    inset: 0,
    zIndex: 8,
    pointerEvents: "auto",
    "&.top, &.bottom": { height: getWidth },
    "&.left, &.right": { width: getWidth },
    "&.top": { top: 0 },
    "&.bottom": { top: "calc(100% - 8px)" },
    "&.left": { left: 0, },
    "&.right": { left: "calc(100% - 8px)" },
  },
}));

export default useStyle;